<template>
    <div>
        <modal :name="modal_name" class="final-modal" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header">
                    <span class="v-modal-dialog-title v-modal-title" style="color: #303031 !important;text-transform:none !important;">Preview Ticket</span>
                    <span class="d-flex align-items-center">
                        <span class="product-logo mr-2">
                            <i class="logo-help-desk" style="color:#00448b !important;"></i>
                        </span>
                        <span class="product-name hidden-md-down fw-500" style="color:#00448b !important;">DigiHelp</span>
                    </span>
                </div>
                <div class="general-section pt-2 pl-0 pr-0 pb-1 m-4">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 410px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;" v-if="source != 'Quotation'">
                            <div class="row boxShadow pl-2 pr-2 ml-2 mr-2 pt-2 pb-5">
                                <div class="col-lg-12 col-md-12 col-sm-12 border-bottom-new" >
                                    <div class="fw-400 pt-2 pb-2 d-inline-block mr-2" style="width: 110px;">Ticket Creator :</div>
                                    <div class="text-black fw-500 d-inline-block ml-2">{{storedDetails.authorized_person_name}}</div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 border-bottom-new" >
                                    <div class="fw-400 pt-2 pb-2 d-inline-block mr-2" style="width: 110px;">Assigned To :</div>
                                    <div class="text-black fw-500 d-inline-block ml-2" v-if="storedDetails.assignedCustomer">{{storedDetails.assignedCustomer.name}}</div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 border-bottom-new" >
                                    <div class="fw-400 pt-2 pb-2 d-inline-block align-middle mr-2" style="width: 110px;">Subject :</div>
                                    <div class="text-black fw-500 d-inline-block align-middle ml-2" style="word-break: break-all;">{{storedDetails.subject}}</div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 border-bottom-new" >
                                    <div class="fw-400 pt-2 pb-2 d-inline-block mr-2" style="vertical-align: top; width: 110px;">Description :</div>
                                    <div class="text-black fw-500 d-inline-block p-description-mail mb-0 ml-2" style="vertical-align: top; padding-top: 10px" v-if="storedDetails.description" v-html="storedDetails.description"></div>
                                    <div v-else>-</div>
                                </div>
                                <!-- <div class="col-lg-12 col-md-12 col-sm-12 border-bottom-new" >
                                    <div class="fw-400 pt-2 pb-2">Department</div>
                                    <div class="text-black fw-500" v-if="storedDetails.department">{{storedDetails.department.name}}</div>
                                </div> -->
                                <div class="pl-2 pr-2 ml-2 mr-2 pt-2 pb-0 mt-3 mb-3 col-lg-12 col-md-12 col-sm-12" v-if="attachments && attachments.length">
                                    <div class="fw-500 pt-2 pb-2" style="border-bottom:1px solid #707070;">Attachments</div>
                                    <div class="pt-2 pl-1 fs-16" v-if="image_attachments.length">Pictures</div>
                                    <div class="d-flex flex-wrap col-lg-7 col-md-7 col-sm-7 pr-0">
                                        <div class="" v-for="(attachment,index) in image_attachments" :key="index">
                                            <div class="d-flex attachment-image mt-2 mr-3 flex-column" :class="{'attachment-image-upload':attachment.progress<100 && attachment.error == ''}">
                                                <span @click="handlePictureCardPreview(attachment)" class="pointer">
                                                    <img :src="attachment.url" alt="" style="width:167px;height:75px">
                                                </span>
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="bottom">
                                                        <div class=" text-center text-truncate d-block mx-width-220 pt-1">
                                                            {{attachment.name}}
                                                        </div>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </div>    
                                        <el-dialog :visible.sync="dialogVisible">
                                            <img :src="dialogImageUrl" alt="">
                                        </el-dialog>
                                    </div>
                                    <div class="pt-2 pl-1 fs-16 fw-500" v-if="audio_video_attachments.length">Videos</div>
                                    <div class="d-flex flex-wrap pr-0 pl-0" >
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="" v-for="(attachment,index) in audio_video_attachments" :key="index">
                                                <div class="d-flex attachment-video mt-2 mr-3 flex-column">
                                                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/video-icon.svg" alt="" width="100px" v-if="attachment.name.endsWith('.mpg') || attachment.name.endsWith('.mpeg')  || attachment.name.endsWith('.wmv') || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.avi')" class="upload-media contentCenter">
                                                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/audio-icon.svg" alt="" width="100px"  class="upload-media-audio contentCenter" v-if="attachment.name.endsWith('.wav') || attachment.name.endsWith('.mp3')">
                                                    <div class="d-flex justify-content-center mt-1">
                                                        <div class=" text-center text-truncate d-block pt-1 fw-500">
                                                            {{attachment.name}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>    
                                        </div>
                                    </div>
                                    <div class="pt-2 pl-1 fs-16" v-if="generic_attachments.length">Files</div>
                                    <div class="d-flex flex-wrap align-items-center mt-4">
                                        <div class="col-lg-4 col-md-4 col-sm-12" v-for="(attachment,index) in generic_attachments" :key="index">
                                            <div class="d-flex align-items-center mt-6 pr-6">
                                                <div class="d-flex align-items-center" style="width:90%">
                                                    <div>
                                                        <img class="contentCenter" width="100px" v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                        <img class="contentCenter" width="100px" v-else-if="attachment.name.endsWith('.ppt') || attachment.name.endsWith('.pptx')" src="https://cdn.digicollect.com/cdn/scmnew/images/ppt.svg">
                                                        <img class="contentCenter" width="100px" v-else-if="attachment.name.endsWith('.html') || attachment.name.endsWith('.htm')" src="https://cdn.digicollect.com/cdn/scmnew/images/html.svg">
                                                        <img class="contentCenter" width="100px" v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/xls.svg">
                                                        <img class="contentCenter" width="100px" v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/doc.svg">
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between contentCenter">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block">
                                                                    {{attachment.name}}
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                            <!-- products -->
                            <div class="borderBottomBlue mt-1"></div>
                            <div class="borderTopBlue"></div>
                            <div class="row boxShadow pl-2 pr-2 ml-2 mr-2 pt-2 pb-5 mt-3 mb-3">
                                <div class="col-lg-12 col-md-12 col-sm-12 border-bottom-new" >
                                    <div class="fw-400 pt-2 pb-2 d-inline-block mr-2">Ticket Template :</div>
                                    <div class="text-black fw-500 d-inline-block" v-if="storedDetails.ticket_template">{{storedDetails.ticket_template.name}}</div>
                                </div>
                                <div class="row boxShadow pl-2 pr-2 ml-2 mr-2 pt-2 pb-5 mt-3 mb-3" v-if="source == 'Product Bug Template'">
                                    <div class="col-lg-6 col-md-6 col-sm-12 border-bottom-new" >
                                        <div class="fw-400 pt-2 pb-2 d-inline-block">Product :</div>
                                        <div class="text-black fw-500 d-inline-block ml-2">{{view_json.products.name}}</div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 border-bottom-new" >
                                        <div class="fw-400 pt-2 pb-2 d-inline-block">Issue Type :</div>
                                        <div class="fw-500 text-black d-inline-block ml-2" style="text-transform: capitalize;" v-if="view_json.type == 'new_feature'">New Feature</div>
                                        <div class="text-black fw-500 d-inline-block ml-2" v-else>{{view_json.type}}</div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 border-bottom-new"  v-if="show_priority">
                                        <div class="fw-400 pt-2 pb-2 d-inline-block">Priority :</div>
                                        <div class="text-black fw-500 d-inline-block ml-2">{{view_json.priority}}</div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 border-bottom-new" >
                                        <div class="fw-400 pt-2 pb-2 d-inline-block">Tags :</div>
                                        <div class="d-inline-block" v-if="view_json.tags.length > 0">
                                            <div class="text-black fw-500" v-for="(tag_text,index) in view_json.tags" :key="index" >{{tag_text.text}}</div>
                                        </div>
                                        <div v-else class="text-black fw-500 d-inline-block ml-2">
                                            -
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 border-bottom-new" >
                                        <div class="fw-400 pt-2 pb-2 d-inline-block text-capitalize">Is it functional bug ? :</div>
                                        <div class="text-black fw-500 d-inline-block ml-2" v-if="view_json.is_functional == true">Yes</div>
                                        <div class="text-black fw-500 d-inline-block ml-2" v-else>No</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important; border-radius: 5px !important;" @click="hideView()">CANCEL</a>
                        <!-- <button type="button" class="btn btn-secondary btn-smm ml-3" style="box-shadow: none;" @click="saveAsDraft" v-if="source != 'Quotation' && (check_ticket_template_type == 'Product' || check_ticket_template_type == 'Equipment')">
                            Save as Draft
                        </button> -->
                        <button type="button" class="btn btn-success btn-smm text-white ml-4" :disabled="is_saving" @click="save()" style="box-shadow: none;">
                            SAVE
                        </button>
                    </div> 
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import convert from '../mixins/convert.js';
import setting from '../mixins/setting.js';
export default {
    props:['modal_name','storedDetails','view_json','productDetails','source', 'check_ticket_template_type', 'is_saving', 'is_service_ticket'],
    mixins:[convert, setting],
    data(){
        return{
            attachments:[],
            generic_attachments:[],
            image_attachments:[],
            audio_video_attachments:[],
            dialogImageUrl: '',
            dialogVisible: false,
            show_priority: false
        }
    },
    methods:{
        handlePictureCardPreview(attachment) {
            this.dialogImageUrl = attachment.url;
            this.dialogVisible = true;
        },
        hideView(){
            this.$modal.hide(this.modal_name);
            this.$emit('cancelTicketDetails')
        },
        save(){
            this.$modal.hide(this.modal_name);
            this.$emit('saveTicketDetails')
        },
        saveAsDraft(){
            this.$modal.hide(this.modal_name);
            this.$emit('saveTicketDetailsAsDraft')
        },
        distinctAttachments(){
            this.generic_attachments = []
            this.image_attachments = []
            this.audio_video_attachments = []
            this.attachments.forEach((el,index)=>{
                if(el.name.endsWith('.doc') || el.name.endsWith('.docx') || el.name.endsWith('.htm') || el.name.endsWith('.html') || el.name.endsWith('.pdf') || el.name.endsWith('.ppt') || el.name.endsWith('.pptx') || el.name.endsWith('.txt') || el.name.endsWith('.xls') || el.name.endsWith('.xlsx')){
                   this.generic_attachments.push(el) 
                }else if(el.name.endsWith('.png') || el.name.endsWith('.PNG') || el.name.endsWith('.jpg') || el.name.endsWith('.JPG') || el.name.endsWith('.svg') || el.name.endsWith('.bmp') || el.name.endsWith('.BMP') || el.name.endsWith('.jpeg') || el.name.endsWith('.JPEG') || el.name.endsWith('.gif') || el.name.endsWith('.tiff')){
                   this.image_attachments.push(el) 
                }else if(el.name.endsWith('.avi') || el.name.endsWith('.flv') || el.name.endsWith('.mpg') || el.name.endsWith('.mpeg') || el.name.endsWith('.mp3') || el.name.endsWith('.mp4') || el.name.endsWith('.wav') || el.name.endsWith('.wmv')){
                   this.audio_video_attachments.push(el) 
                }
            })
        },
        capitalize(string){
            if(string){
                return string[0].toUpperCase() + string.substring(1);
            }else{
                return ''
            }
            
        },
        async getIsShowPriority() {
            let param = {
                settings_type: ['display_ticket_priorities']
            }
            let data = await this.getAllJobTypes(param);
            this.show_priority = data.response.display_ticket_priorities.display_ticket_priorities;
        },
    },
    mounted(){
        this.getIsShowPriority();
        this.attachments = this.view_json.attach_files
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
        product_naming_convention(){
            if(this.getGeneralSettings){
                return this.capitalize(this.getGeneralSettings.namingConventionOfProducts)
            }else{
                return ''
            }
        },
    },
    watch:{
        'attachments'(newValue,oldValue){
            if(newValue){
                this.distinctAttachments()
            }
        }
    },
}
</script>
<style scoped>
.borderBottomBlue{
    border-bottom: 1px solid #00448b !important;
    padding-top: 5px;
}
.borderTopBlue{
    border-top: 1px solid #00448b !important;
    padding-top: 5px;
}
.boxShadow{
    box-shadow: 0px 0.5px 7px 2px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    border-radius: 8px;
}
.borderBottom{
    border-bottom: 1px solid #808081;
}
.border-bottom-new {
    border-bottom: solid 0.3px #add2fc; 
    padding-bottom: 5px;
}
.p-description-mail {
    white-space: normal !important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #4e5764;
    margin-bottom: 30px;
}
.p-description-mail {
    overflow-y: visible !important;
    overflow-x: scroll;
}
</style>